/* eslint-disable camelcase */
import { API } from './env'

class HttpUtils {
  constructor() {
    this.api = API
    return this
  }

  getApi() {
    /* if (
      window.location.origin !== 'http://localhost:3000' &&
      window.location.origin !== 'https://medsis-stg.medlevensohn-stage.com' &&
      window.location.origin !== 'https://medsis.medlevensohn.com'
    ) {
      if (window.location.origin.includes('localhost')) {
        return (
          window.location.origin.split(window.location.port)[0] + '8080/api/v1'
        )
      }
      return (
        window.location.origin.split(window.location.port)[0] + ':8080/api/v1'
      )
    }

    console.log("process?.env?.REACT_APP_NODE_ENV: ", process?.env?.REACT_APP_NODE_ENV)
    console.log("process?.env?.NODE_ENV: ", process?.env?.NODE_ENV)

    if (process?.env?.REACT_APP_NODE_ENV === 'stage' || process?.env?.NODE_ENV === 'stage') {
      return 'https://medsis-api.medlevensohn-stage.com/api/v1'
    }

    if (process?.env?.NODE_ENV === 'development' || process?.env?.NODE_ENV === 'development') {
      return 'https://medsis-api.medlevensohn-stage.com/api/v1'
    } */

    //return 'https://medsis.medlevensohn.com:8443/api/v1'

    //return 'https://medsis-api.medlevensohn-stage.com/api/v1';

    return 'https://medsis.medlevensohn.com:8443/api/v1';
  }
}

export default new HttpUtils()
